export type DashboardClientScope = 'mine' | 'all';

export const DASHBOARD_CLIENT_SCOPE_STORAGE_KEY = 'dashboardClientScope';

export interface DashboardMetricTile {
  current: number;
  previous?: number | null;
}

export interface UpcomingOpenEnrollmentTile {
  next30Days: number;
  next7Days: number;
}

export interface DashboardMetrics {
  scope: DashboardClientScope;
  associatedClients: DashboardMetricTile;
  activeMembers: DashboardMetricTile;
  enrollmentsAwaitingAcknowledgement: DashboardMetricTile;
  upcomingOpenEnrollment: UpcomingOpenEnrollmentTile;
}

export interface DashboardRecentAssignmentItem {
  mCode: string;
  clientName: string;
  assignmentTypeCode: string;
  effectiveFrom: string;
  handedOffFromSales: boolean;
  staffDisplayName: string;
}

export interface DashboardRecentAssignments {
  scope: DashboardClientScope;
  items: DashboardRecentAssignmentItem[];
}

export interface DashboardUpcomingOpenEnrollmentItem {
  mCode: string;
  cCode: string;
  clientName: string;
  openDate: string;
  daysUntilOpen: number;
}

export interface DashboardUpcomingOpenEnrollments {
  scope: DashboardClientScope;
  items: DashboardUpcomingOpenEnrollmentItem[];
}

export type DashboardAccountAttentionReason = 'PastDue30' | 'LapsedNonPayment' | 'Lapsed';

export interface DashboardAccountNeedingAttentionItem {
  mCode: string;
  clientName: string;
  reason: DashboardAccountAttentionReason;
  daysPastDue?: number | null;
  coverageEndedOn?: string | null;
}

export interface DashboardAccountsNeedingAttention {
  scope: DashboardClientScope;
  items: DashboardAccountNeedingAttentionItem[];
}

export interface DashboardEnrollmentsAwaitingAcknowledgementItem {
  mCode: string;
  cCode: string;
  clientName: string;
  pendingCount: number;
}

export interface DashboardEnrollmentsAwaitingAcknowledgement {
  scope: DashboardClientScope;
  items: DashboardEnrollmentsAwaitingAcknowledgementItem[];
}

export interface DashboardMembersOverTimePoint {
  monthStart: string;
  productTypeName: string;
  memberCount: number;
}

export interface DashboardMembersOverTime {
  scope: DashboardClientScope;
  points: DashboardMembersOverTimePoint[];
}
